import { DefaultUploadImages } from '../defaults';
import { Illustartions } from '@agilepoint/web-components';
import { useTranslate } from '@agilepoint/wat-react';
import { AppLogoTilePreviewLayout } from './app-logo-tile-preview-layout';
import { UploadImagesFormFields } from '../types';

export const useIosAppTileInfo = () => {
    const translate = useTranslate();

    return [{
        headingLabel: translate('modules.createNewApp.steps.uploadImages.iosCustomImagesDetails.iosAppInfo'),
        logoTileDetails: [
            // {
            //     imageType: translate('modules.createNewApp.steps.uploadImages.iosCustomImagesDetails.iphoneLabel'),
            //     imageSize: '120 x 120',
            //     imagePickerFieldName: UploadImagesFormFields.iosAppIconiphone,
            //     resetImageURL: DefaultUploadImages.AppIcon
            // },
            // {
            //     imageType: translate('modules.createNewApp.steps.uploadImages.iosCustomImagesDetails.ipadLabel'),
            //     imageSize: '152 x 152',
            //     imagePickerFieldName: UploadImagesFormFields.iosAppIconipad,
            //     resetImageURL: DefaultUploadImages.AppIcon
            // },
            {
                imageType: translate('modules.createNewApp.steps.uploadImages.iosCustomImagesDetails.defaultIconLabel'),
                imageSize: '1024 x 1024',
                imagePickerFieldName: UploadImagesFormFields.iosAppDefaultIcon,
                resetImageURL: DefaultUploadImages.AppIcon
            },
            {
                imageType: translate('modules.createNewApp.steps.uploadImages.appLogoDetails.appLogoText'),
                imageSize: '175 x 40',
                imagePickerFieldName: UploadImagesFormFields.iosAppApplicationLogo,
                resetImageURL: DefaultUploadImages.AppIcon
            }
        ],
        appIllustrationName: 'maa-ios-app-icon-illustration' as keyof Illustartions
    },
    {
        headingLabel: translate('modules.createNewApp.steps.uploadImages.iosCustomImagesDetails.splashScreenHeader'),
        logoTileDetails: [
            // {
            //     imageType: 'iPhone',
            //     imageSize: '640 x 1136',
            //     imagePickerFieldName: UploadImagesFormFields.iosSplashScreeniphone,
            //     resetImageURL: DefaultUploadImages.SplashScreenPortrait
            // },
            {
                imageType: translate('modules.createNewApp.steps.uploadImages.splashScreenAppDetails.splashScreenText'),
                imageSize: '375 x 811',
                imagePickerFieldName: UploadImagesFormFields.iosSplashScreeniphone,
                resetImageURL: DefaultUploadImages.SplashScreenPortrait
            }
        ],
        appIllustrationName: 'maa-ios-splashscreen-illustration' as keyof Illustartions
    }];
};

export const IOSTabContent = () => {
    const appTileMetadata = useIosAppTileInfo();
    return (
        <AppLogoTilePreviewLayout appTileMetadata={appTileMetadata} />
    );
};
